const _REQUEST = "_REQUEST";
const _SUCCESS = "_SUCCESS";
const _FAIL = "_FAIL";
const LOGIN_PREFIX = "LOGIN";
const USER_PREFIX = "USER";
const SITE_STATISTIC_PREFIX = "SITE_STATISTIC";
const STORE_STATISTIC_PREFIX = "STORE_STATISTIC";

export default {
  SET_THEME: "SET_THEME",
  SET_IS_LOGGED_IN: "SET_IS_LOGGED_IN",
  SET_STORE_NAME: "SET_STORE_NAME",
  LOGOUT: "LOGOUT",
  SET_BREADCRUMBS: "SET_BREADCRUMBS",
  NAVIGATE_BREADCRUMBS: "NAVIGATE_BREADCRUMBS",

  // login
  LOGIN_PREFIX,
  LOGIN_REQUEST: LOGIN_PREFIX + _REQUEST,
  LOGIN_SUCCESS: LOGIN_PREFIX + _SUCCESS,
  LOGIN_FAIL: LOGIN_PREFIX + _FAIL,

  // user
  USER_PREFIX,
  USER_REQUEST: USER_PREFIX + _REQUEST,
  USER_SUCCESS: USER_PREFIX + _SUCCESS,
  USER_FAIL: USER_PREFIX + _FAIL,
  TOGGLE_TWO_FACTOR: "TOGGLE_TWO_FACTOR",

  // site statistic
  SITE_STATISTIC_PREFIX,
  SITE_STATISTIC_REQUEST: SITE_STATISTIC_PREFIX + _REQUEST,
  SITE_STATISTIC_SUCCESS: SITE_STATISTIC_PREFIX + _SUCCESS,
  SITE_STATISTIC_FAIL: SITE_STATISTIC_PREFIX + _FAIL,

  // store statistic
  STORE_STATISTIC_PREFIX,
  STORE_STATISTIC_REQUEST: STORE_STATISTIC_PREFIX + _REQUEST,
  STORE_STATISTIC_SUCCESS: STORE_STATISTIC_PREFIX + _SUCCESS,
  STORE_STATISTIC_FAIL: STORE_STATISTIC_PREFIX + _FAIL,
};
